import { ExternalLinkIcon } from "@heroicons/react/outline";

export interface SettingsPageHeaderProps {
  title: string;
  description?: string;
  docsLink?: string;
  name?: string;
}

export const SettingsPageHeader = ({
  title,
  description,
  docsLink,
  name,
}: SettingsPageHeaderProps) => {
  if (!title && !description) {
    return null;
  }

  return (
    <div className="mb-2 border-b border-gray-200 pb-3.5">
      <div className="flex w-full items-center justify-between">
        {title && <h1 className="text-xl font-semibold text-gray-900">{title}</h1>}
        {docsLink && name && (
          <a
            href={docsLink}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700"
          >
            Learn more about {name.toLowerCase()} here
            <ExternalLinkIcon className="h-4 w-auto text-gray-500 group-hover:text-gray-700" />
          </a>
        )}
      </div>
      {description && <p className="text-xs text-gray-600">{description}</p>}
    </div>
  );
};

// Keep the old component for backward compatibility during transition
export interface HeaderProps {
  title: string;
  name: string;
  description: string;
  docsLink: string;
}

export const SettingsHeader = ({ title, name, description, docsLink }: HeaderProps) => (
  <SettingsPageHeader title={title} description={description} docsLink={docsLink} name={name} />
);
